import { useTranslation } from 'react-i18next';
import { runStatusLabel } from '../lib/format';
import { RUN_STATUS_BADGE_CLASS, runStatusVariant } from '../lib/run-status';
import { cn } from '@shared/lib/utils';

interface ReconciliationRunStatusBadgeProps {
  status: string;
  className?: string;
}

export function ReconciliationRunStatusBadge({ status, className }: ReconciliationRunStatusBadgeProps) {
  const { t } = useTranslation('cabinet');
  const variant = runStatusVariant(status);

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        RUN_STATUS_BADGE_CLASS[variant],
        className,
      )}
    >
      {runStatusLabel(t, status)}
    </span>
  );
}
